import {
  recognitionDashboardService,
  RecognitionOverviewResponse,
  RecognitionLeaderboardValuesResponse,
  RecognitionEmployeeLeaderboardResponse,
  EngagedLeaderboardResponse,
  GroupLeaderboardResponse,
  PotLeaderboardResponse,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchRecognitionOverview = (companyId: string, enabled = true) => {
  return useQuery<RecognitionOverviewResponse, Error>({
    queryKey: ['fetchRecognitionOverview', companyId],
    queryFn: () => recognitionDashboardService.getRecognitionOverview(companyId),
    enabled: enabled && !!companyId,
  });
};

const useFetchValuesLeaderboard = (companyId: string, limit: number, enabled = true) => {
  return useQuery<RecognitionLeaderboardValuesResponse, Error>({
    queryKey: ['fetchValuesLeaderboard', companyId, limit],
    queryFn: () => recognitionDashboardService.getValuesLeaderboard(companyId, limit),
    enabled: enabled && !!companyId,
  });
};

const useFetchMostRecognisedEmployees = (companyId: string, limit: number, enabled = true) =>
  useQuery<RecognitionEmployeeLeaderboardResponse, Error>({
    queryKey: ['fetchMostRecognisedEmployees', companyId, limit],
    queryFn: () => recognitionDashboardService.getMostRecognisedEmployees(companyId, limit),
    enabled: enabled && !!companyId,
  });

const useFetchMostEngagedEmployees = (companyId: string, limit: number, enabled = true) =>
  useQuery<EngagedLeaderboardResponse, Error>({
    queryKey: ['fetchMostEngagedEmployees', companyId, limit],
    queryFn: () => recognitionDashboardService.getMostEngagedEmployees(companyId, limit),
    enabled: enabled && !!companyId,
  });

const useFetchGroupsLeaderboard = (companyId: string, limit: number, enabled = true) =>
  useQuery<GroupLeaderboardResponse, Error>({
    queryKey: ['fetchGroupsLeaderboard', companyId, limit],
    queryFn: () => recognitionDashboardService.getGroupsLeaderboard(companyId, limit),
    enabled: enabled && !!companyId,
  });

const useFetchPotsLeaderboard = (companyId: string, limit: number, enabled = true) =>
  useQuery<PotLeaderboardResponse, Error>({
    queryKey: ['fetchPotsLeaderboard', companyId, limit],
    queryFn: () => recognitionDashboardService.getPotsLeaderboard(companyId, limit),
    enabled: enabled && !!companyId,
  });

const useRecognitionDashboard = {
  useFetchRecognitionOverview,
  useFetchValuesLeaderboard,
  useFetchMostRecognisedEmployees,
  useFetchMostEngagedEmployees,
  useFetchGroupsLeaderboard,
  useFetchPotsLeaderboard,
};

export default useRecognitionDashboard;
